import { render } from "./LastTransactions.vue?vue&type=template&id=442d3952&scoped=true"
import script from "./LastTransactions.vue?vue&type=script&lang=js"
export * from "./LastTransactions.vue?vue&type=script&lang=js"

import "./LastTransactions.vue?vue&type=style&index=0&id=442d3952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442d3952"]])

export default __exports__